const flatpickr = require('flatpickr');
const Polish = require('flatpickr/dist/l10n/pl').default.pl

flatpickr.localize(Polish);
class FlatpickrDirective {
    constructor() {
        this.restrict = 'A';
        this.require = 'ngModel';
        this.scope = {
            fpOpts: '&',
            fpOnSetup: '&'
        };
    }

    link(scope, element, attrs, ngModel) {
        let vp = new flatpickr(element[0], scope.fpOpts());

        element.addClass('ng-untouched');

        vp.config.onChange.push(function(selectedDates, viewDates) {
            scope.$evalAsync(function() {
                ngModel.$setViewValue(viewDates);
            });
        });

        element.on('click', function() {
            element.removeClass('ng-untouched');
            element.addClass('ng-touched');
        })

        if (scope.fpOnSetup) {
            scope.fpOnSetup({
                fpItem : vp
            });
        }
    }

    static directiveFactory() {
        'ngInject';
        return new FlatpickrDirective();
    }
}

export default FlatpickrDirective;
